import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="goodbye-malaria" style={{
      backgroundColor: 'var(--color-white)',
      padding: '60px 0 40px',
      borderTop: '1px solid rgb(var(--color-border))'
    }}>
      <div className="container">
        {/* Desktop Footer Content */}
        <div className="gm-footer-main gm-footer-desktop">
          {/* Goodbye Malaria Section */}
          <div className="gm-footer-section">
            <h5 style={{
              marginBottom: '16px'
            }}>
              GOODBYE MALARIA
            </h5>
            <p style={{
              margin: 0,
              maxWidth: '280px'
            }}>
              Every product is locally and ethically produced, uplifting and upskilling 
              entrepreneurs from diverse backgrounds and cultures. Your purchase helps 
              our malaria elimination efforts in Southern Africa.
            </p>
          </div>

          {/* Shop Section */}
          <div className="gm-footer-section">
            <h5 style={{
              marginBottom: '16px'
            }}>
              SHOP
            </h5>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              <li style={{ marginBottom: '8px' }}>
                <a href="https://shop.goodbyemalaria.com/collections/apparel">Apparel</a>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <a href="https://shop.goodbyemalaria.com/collections/childrens-clothing">Kiddies Corner</a>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <a href="https://shop.goodbyemalaria.com/collections/accessories">Accessories</a>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <a href="https://shop.goodbyemalaria.com/collections/home">Homeware</a>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <a href="https://shop.goodbyemalaria.com/pages/corporate-gifting">Corporate</a>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <a href="https://shop.goodbyemalaria.com/collections/goodbye-deals">Good Buys</a>
              </li>
            </ul>
          </div>

          {/* Legal Section */}
          <div className="gm-footer-section">
            <h5 style={{
              marginBottom: '16px'
            }}>
              LEGAL
            </h5>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              <li style={{ marginBottom: '8px' }}>
                <a href="https://shop.goodbyemalaria.com/search">Search</a>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <a href="https://shop.goodbyemalaria.com/policies/refund-policy">Refunds & Returns</a>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <a href="https://shop.goodbyemalaria.com/policies/privacy-policy">Privacy Policy</a>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <a href="https://shop.goodbyemalaria.com/policies/terms-of-service">Terms of Service</a>
              </li>
            </ul>
          </div>

        </div>

        {/* Mobile Footer Content */}
        <div className="gm-footer-mobile">
          {/* Main Brand Section */}
          <div className="gm-footer-brand">
            <h5>GOODBYE MALARIA</h5>
            <p>
              Every product is locally and ethically produced, uplifting and upskilling 
              entrepreneurs from diverse backgrounds and cultures. Your purchase helps 
              our malaria elimination efforts in Southern Africa.
            </p>
          </div>

          {/* Quick Links Grid */}
          <div className="gm-footer-links">
            <div className="gm-footer-link-group">
              <h6>SHOP</h6>
              <a href="https://shop.goodbyemalaria.com/collections/apparel">Apparel</a>
              <a href="https://shop.goodbyemalaria.com/collections/childrens-clothing">Kiddies Corner</a>
              <a href="https://shop.goodbyemalaria.com/collections/accessories">Accessories</a>
              <a href="https://shop.goodbyemalaria.com/collections/home">Homeware</a>
              <a href="https://shop.goodbyemalaria.com/pages/corporate-gifting">Corporate</a>
              <a href="https://shop.goodbyemalaria.com/collections/goodbye-deals">Good Buys</a>
            </div>
            
            <div className="gm-footer-link-group">
              <h6>LEGAL</h6>
              <a href="https://shop.goodbyemalaria.com/search">Search</a>
              <a href="https://shop.goodbyemalaria.com/policies/refund-policy">Refunds & Returns</a>
              <a href="https://shop.goodbyemalaria.com/policies/privacy-policy">Privacy Policy</a>
              <a href="https://shop.goodbyemalaria.com/policies/terms-of-service">Terms of Service</a>
            </div>
          </div>

          {/* Mobile Footer Bottom */}
          <div className="gm-footer-mobile-bottom" style={{ paddingBottom: '40px' }}>
            <div className="gm-footer-tax-section">
              <h6>SECTION 18A TAX CERTIFICATES</h6>
              <p>
                We are a registered Public Benefit Organisation and can issue donors with Section 18A Tax Certificates. Please get in touch with <a href="mailto:info@goodbyemalaria.com">info@goodbyemalaria.com</a> should you require a certificate.
              </p>
            </div>
            
            <div className="gm-footer-copyright">
              <p>2025, Goodbye Malaria.</p>
            </div>
          </div>
        </div>

      </div>

      {/* Footer Bottom - Duplicate */}
      <div className="gm-footer-bottom" style={{
        borderTop: '1px solid var(--color-light-grey)',
        backgroundColor: 'var(--color-white)',
        padding: '30px 0 20px'
      }}>
        <div className="container">

          {/* Section 18A Tax Certificate */}
          <div style={{
            paddingTop: '24px',
            marginBottom: '24px'
          }}>
            <h5 style={{
              marginBottom: '12px'
            }}>
              SECTION 18A TAX CERTIFICATES
            </h5>
            <p style={{
              margin: 0,
              maxWidth: '800px'
            }}>
              We are a registered Public Benefit Organisation and can issue donors with Section 18A Tax Certificates. Please get in touch with <a href="mailto:info@goodbyemalaria.com" style={{
                color: 'var(--color-grey)',
                textDecoration: 'underline'
              }}>info@goodbyemalaria.com</a> should you require a certificate.
            </p>
          </div>

          {/* Copyright */}
          <div>
            <p style={{
              margin: 0,
              textAlign: 'center'
            }}>
              2025, Goodbye Malaria.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
